<template>
    <div v-if="show">
        <div class="z-50"
            :style="dropdownStyle"
        >
            <div class="bg-white rounded-lg shadow-lg border border-gray-200 py-1 min-w-48">
                <div v-for="item in items"
                    :key="item.key"
                    class="px-3 py-1.5 text-sm hover:bg-gray-100 cursor-pointer flex items-center"
                    :class="item.color === 'red' ? 'text-red-600' : 'text-gray-700'"
                    @click.stop="handleItemClick(item)"
                >
                    <i v-if="item.icon"
                        :class="item.icon"
                        class="mr-2 mb-0.5 w-4 text-center">
                    </i>

                    {{ item.label }}
                </div>
            </div>
        </div>

        <div class="fixed bg-transparent inset-0 z-10"
            @click.stop="closeDropdown"
        >
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContextualDropdown',
    
    props: {
        show: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            default: () => []
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
    },
    
    computed: {
        dropdownStyle() {
            // Adjust position to prevent dropdown from going off-screen
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const dropdownWidth = 192; // min-w-48 = 192px
            const dropdownHeight = 200; // estimated height
            
            let left = this.x - 150;
            let top = this.y - 20;
            
            // Adjust horizontal position if dropdown would go off-screen
            if (left + dropdownWidth > viewportWidth) {
                left = viewportWidth - dropdownWidth - 25;
            }
            
            // Adjust vertical position if dropdown would go off-screen
            if (top + dropdownHeight > viewportHeight) {
                top = viewportHeight - dropdownHeight - 25;
            }
            
            return {
                left: `${left}px`,
                top: `${top}px`,
                position: 'fixed'
            };
        }
    },
    
    methods: {
        handleItemClick(item) {
            this.$emit('item-clicked', item);
            this.$emit('close');
        }
    },
    
    mounted() {
        document.addEventListener('keydown', this.handleKeydown);
    },

    beforeUnmount() {
        document.removeEventListener('keydown', this.handleKeydown);
    },
    
    methods: {
        closeDropdown() {
            this.$emit('close');
        },
        handleItemClick(item) {
            this.$emit('item-clicked', item);
            this.closeDropdown();
        },
        handleKeydown(event) {
            if (event.key === 'Escape') {
                this.closeDropdown();
            }
        },
    },
}
</script>
